<template>
  <div>
    <div class="clearfix">
      <!--发票表格     start--->
      <div class="invoice_wrap  fl">

        <!--空白发票在此标签，加类名 invoice_gray-->
        <div>
          <!--公共样式部分 发票类型 发票状态 灰层-->
          <div class="invoice_base">
            <p class="invoice_type"><span id="invoiceType">{{invoiceTypes}}</span></p>
            <span
              :class="['invoice_state',invoiceState]"
              id="invoiceState"
            >

            </span>
            <!--异常：abnormal，失控：outcontrol，红冲：red，作废：void-->
            <!-- <div class="mask"></div> -->
            <i class="iconfont icon-yinzhang check_result_icon "></i>
          </div>
          <h1 class="invoice_tit"><span><i
                id="invoiceTit"
                style="display:block"
              >
                {{invoiceData.administrativeDivisionName}}
                {{invoiceData.invoiceType}}

              </i></span></h1>
          <ul class="invoice_top_info clearfix">
            <li>发票代码：<span><i
                  class="content_td_blue"
                  id="invoiceCode"
                >{{invoiceData.invoiceCode}} </i></span></li>
            <li>发票号码：<span><i
                  class="content_td_blue"
                  id="invoiceNumber"
                >{{invoiceData.invoiceNumber}} </i></span></li>
          </ul>
          <ul class="invoice_top_info_right clearfix">
            <li>校验码：<span><i
                  class="content_td_blue"
                  id="checkCode"
                > {{invoiceData.checkCode}}</i></span></li>
            <!--<li>机器编号：<span><i class="content_td_blue" id="machineCode">661513553240</i></span></li>-->
            <li>开票日期：<span><i
                  class="content_td_blue"
                  id="billingDate"
                > {{farmatData(invoiceData.billingDate)}}</i></span></li>
          </ul>
          <table
            class="fppy_table"
            style="width: 100%;"
            border="0"
            cellspacing="0"
            cellpadding="0"
          >
            <tbody>
              <tr>
                <td
                  width="20"
                  class="align_center"
                  rowspan="4"
                >
                  <p>购</p>
                  <p>买</p>
                  <p>方</p>
                </td>
                <td
                  width="120"
                  class="align_left borderNo"
                >名<i style="display: inline-block; width: 4em;"></i>称：
                </td>
                <td class="align_left borderNo bgcolorWhite"><span
                    class="content_td_blue"
                    id="purchaserName"
                  >{{invoiceData.purchaserName}}</span>
                </td>
                <td
                  width="20"
                  class="align_center"
                  rowspan="4"
                >
                  <p>密</p>
                  <p>码</p>
                  <p>区</p>
                </td>
                <td
                  width="260"
                  class="align_left"
                  nowrap=""
                  rowspan="4"
                  id="password_zp"
                >&nbsp;</td>
              </tr>
              <tr>
                <td class="align_left borderNo">纳税人识别号：</td>
                <td
                  class="align_left borderNo"
                  nowrap=""
                ><span
                    class="content_td_blue"
                    id="purchaserTaxNo"
                  >{{invoiceData.purchaserTaxNo}}</span>
                </td>
              </tr>
              <tr>
                <td
                  class="align_left borderNo"
                  valign="top"
                >地 址、 电 话：</td>
                <td
                  class="align_left borderNo"
                  valign="top"
                ><span
                    class="content_td_blue ft12"
                    id="purchaserAddressPhone"
                  >{{invoiceData.purchaserAddressPhone}}</span>
                </td>
              </tr>
              <tr>
                <td
                  class="align_left borderNo"
                  valign="top"
                >开户行及账号：</td>
                <td
                  class="align_left borderNo"
                  valign="top"
                ><span
                    class="content_td_blue"
                    id="purchaserBank"
                  >{{invoiceData.purchaserBank}}</span>
                </td>

              </tr>

              <!--表头-->
              <tr>
                <td colspan="5">
                  <table
                    class="fppy_table_box"
                    style="width: 100%;"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tbody>
                      <tr height="30px">
                        <td
                          width="30%"
                          class="align_center borderRight"
                        >货物或应税劳务名称</td>
                        <td
                          width="10%"
                          class="align_center borderRight"
                        >规格型号</td>
                        <td
                          width="5%"
                          class="align_center borderRight"
                        >单位</td>
                        <td
                          width="10%"
                          class="align_center borderRight"
                        >数量</td>
                        <td
                          width="10%"
                          class="align_center borderRight"
                        >单价</td>
                        <td
                          width="15%"
                          class="align_center borderRight"
                        >金额</td>
                        <td
                          width="5%"
                          class="align_center borderRight"
                        >税率</td>
                        <td
                          width="15%"
                          class="align_center"
                        >税额</td>
                      </tr>
                      <!---->

                      <tr
                        v-if="invoiceData.items && invoiceData.items.length > 8"
                        id="showGoodsListRow"
                        @click="visible=true"
                      >
                        <td
                          class="align_left borderRight"
                          style="position: relative;"
                        >
                          <!--<span class="content_td_blue">(详见销货清单)</span>-->
                          <span
                            class="list_detail_btn"
                            id="goodsList"
                          >详见货物清单</span>
                        </td>
                        <td class="align_left borderRight"><span class="content_td_blue"></span></td>
                        <td class="align_left borderRight"><span class="content_td_blue"></span></td>
                        <td class="align_right borderRight"><span class="content_td_blue"></span></td>
                        <td class="align_right borderRight"><span class="content_td_blue"></span></td>
                        <td class="align_right borderRight"><span class="content_td_blue"></span></td>
                        <td class="align_right borderRight"><span class="content_td_blue"></span></td>
                        <td class="align_right"><span class="content_td_blue"></span></td>
                      </tr>

                      <tr
                        class="invoice_shop_list"
                        v-for="(item,index) in invoiceData.items"
                        :key="index"
                        :class="['invoice_shop_list',displayNone]"
                      >
                        <td class="align_center borderRight"><span class="content_td_blue commodityName"> {{item.commodityName}} </span></td>
                        <td class="align_center borderRight"><span class="content_td_blue specificationModel">{{item.specificationModel}}</span></td>
                        <td class="align_center borderRight"><span class="content_td_blue unit">{{item.unit}}</span></td>
                        <td class="align_center borderRight"><span class="content_td_blue quantity">{{item.quantity}}</span>
                        </td>
                        <td class="align_center borderRight"><span class="content_td_blue unitPrice">{{item.unitPrice?parseFloat(item.unitPrice):''}}</span>
                        </td>
                        <td class="align_center borderRight"><span class="content_td_blue amount"> {{item.amount?parseFloat(item.amount):''}} </span>
                        </td>
                        <td class="align_center borderRight"><span class="content_td_blue taxRate">{{item.taxRate?item.taxRate*100:''}}%</span>
                        </td>
                        <td class="align_center"><span class="content_td_blue tax"> {{item.tax?parseFloat(item.tax):''}} </span></td>
                      </tr>

                      <tr
                        id="statisticsRow"
                        height="50"
                        style="vertical-align: bottom;"
                      >
                        <td class="align_center borderRight">合计</td>
                        <td class="align_center borderRight">&nbsp;</td>
                        <td class="align_center borderRight">&nbsp;</td>
                        <td class="align_center borderRight">&nbsp;</td>
                        <td class="align_center borderRight">&nbsp;</td>
                        <td class="align_right borderRight"><span
                            class="content_td_blue"
                            id="totalAmount"
                          >{{invoiceData.totalAmount?`￥ ${invoiceData.totalAmount}`:'￥'}}</span>
                        </td>
                        <td class="align_center borderRight">&nbsp;</td>
                        <td class="align_right"><span
                            class="content_td_blue"
                            id="totalTax"
                          >{{invoiceData.totalTax?`￥ ${invoiceData.totalTax}`:'￥'}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="align_center borderRight borderTop">价税合计（大写）</td>
                        <td
                          class="align_left borderTop"
                          colspan="4"
                        ><span
                            class="content_td_blue"
                            id="amountTaxCn"
                          >{{invoiceData.amountTaxCn?`⊗  ${invoiceData.amountTaxCn}`:'⊗'}}</span>
                        </td>
                        <td
                          class="align_left borderTop"
                          colspan="3"
                        ><span style="padding: 0px 20px;">（小写）</span><span
                            class="content_td_blue"
                            id="amountTax"
                          >{{invoiceData.amountTax?`￥ ${invoiceData.amountTax}`:'￥'}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <!--表头结束-->
              <tr>
                <td
                  class="align_center"
                  rowspan="4"
                >
                  <p>销</p>
                  <p>售</p>
                  <p>方</p>
                </td>
                <td class="align_left borderNo">名<i style="display: inline-block; width: 4em;"></i>称：</td>
                <td class="align_left borderNo"><span
                    class="content_td_blue"
                    id="salesName"
                  >{{invoiceData.salesName||""}}</span>
                </td>
                <td
                  width="20"
                  class="align_center"
                  rowspan="4"
                >
                  <p>备</p>
                  <p>注</p>
                </td>
                <td
                  width="260"
                  class="align_left"
                  valign="top"
                  rowspan="4"
                >
                  <p
                    class="content_td_blue"
                    id="remarks"
                    v-html="invoiceData.remarks"
                  >
                    <!-- {{invoiceData.remarks||""}} -->
                  </p>
                </td>
              </tr>
              <tr>
                <td class="align_left borderNo">纳税人识别号：</td>
                <td class="align_left borderNo"><span
                    class="content_td_blue"
                    id="salesTaxNo"
                  >{{invoiceData.salesTaxNo||""}}</span></td>
              </tr>
              <tr>
                <td
                  class="align_left borderNo"
                  valign="top"
                >地 址、 电 话：</td>
                <td
                  class="align_left borderNo"
                  valign="top"
                ><span
                    class="content_td_blue ft12"
                    id="salesAddressPhone"
                  >{{invoiceData.salesAddressPhone||""}}</span>
                </td>
              </tr>
              <tr>
                <td
                  class="align_left borderNo"
                  valign="top"
                >开户行及账号：</td>
                <td
                  class="align_left borderNo"
                  valign="top"
                ><span
                    class="content_td_blue"
                    id="salesBank"
                  >{{invoiceData.salesBank||""}}</span>
                </td>
              </tr>
            </tbody>
          </table>

        </div>

      </div>
      <!--发票表格     end--->
    </div>
    <van-popup
      v-model="visible"
      closeable
      :style="{ width: '94%' }"
    >
      <InvoiceNormalDetail :invoiceData="invoiceData" />
    </van-popup>

  </div>
</template>
<script>
import moment from 'moment';
import InvoiceNormalDetail from './InvoiceNormalDetail.vue';

export default {
  name: 'invoice',
  data() {
    return {
      visible: false,
      displayNone: '',
    };
  },
  props: ['invoiceData', 'invoiceState', 'invoiceTypes', 'invoiceTit'],
  created() {
    if (this.invoiceData && this.invoiceData.items && this.invoiceData.items.length >= 8) {
      this.displayNone = 'displayNone';
    }
  },
  methods: {
    farmatData(date) {
      if (!date) return '';
      console.log('date===', date);
      return moment(date).format('YYYY 年 MM 月 DD 日');
    },
  },
  components: {
    InvoiceNormalDetail,
  },
  watch: {
    invoiceTypes: {
      handler(n) {
        console.log('n======', n);
        console.log('n====', this.invoiceTypes);
      },
      immediate: true,
    },
  },
};
</script>
<style scoped  src="../invoice.css"></style>
<style scoped  src="../checkResult.css"></style>
<style  scoped>
.invoice_wrap {
  font-size: 10px;
}
.invoice_gray .invoice_state,
.invoice_gray .invoice_type,
.invoice_gray .content_td_blue {
  display: block;
}
</style>
